import {
  AlertDialog,
  AlertDialogBody,
  AlertDialogContent,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogOverlay,
  Button,
} from '@chakra-ui/react'
import React, { ReactNode } from 'react'

type Props = {
  children: ReactNode
  isOpen: boolean
  onClose: () => void
  onConfirm: () => void
}

export const ConfirmationDialog = ({
  isOpen,
  children,
  onClose,
  onConfirm,
}: Props) => {
  const cancelRef = React.useRef(null)

  const confirmHandler = () => {
    onConfirm()
    onClose()
  }

  return (
    <AlertDialog
      isOpen={isOpen}
      leastDestructiveRef={cancelRef}
      onClose={onClose}
    >
      <AlertDialogOverlay>
        <AlertDialogContent>
          <AlertDialogHeader fontSize="lg" fontWeight="bold">
            Confirma
          </AlertDialogHeader>

          <AlertDialogBody>{children}</AlertDialogBody>

          <AlertDialogFooter>
            <Button ref={cancelRef} onClick={onClose}>
              Cancelar
            </Button>

            <Button colorScheme="primary" onClick={confirmHandler} ml={3}>
              Confirmar
            </Button>
          </AlertDialogFooter>
        </AlertDialogContent>
      </AlertDialogOverlay>
    </AlertDialog>
  )
}
